import { Heading, VStack } from '@chakra-ui/react';
import { WhatsappFloatingBall } from '../../../../packages/ui/components/atoms/WhatsappFloatingBall';
import { ContactForm } from '../../../../packages/ui/forms/ContactForm';
import { MainTemplate } from '../templates/MainTemplate';

export function ContactPage() {
  return (
    <MainTemplate hideBottomMenu>
      <WhatsappFloatingBall />
      <VStack align={'flex-start'} width={'90%'} maxW={'600px'} paddingTop={'50px'}>
        <Heading paddingBottom={'10px'}>Contato</Heading>
        <ContactForm />
      </VStack>
    </MainTemplate>
  );
}
